/* eslint-disable consistent-return */
import { Form, ImageContent, MapCard, OpenCard, SubitleCard, TitleCard } from './styles';
import React, { useContext, useRef, useState } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { FrameData } from '../../components/FrameData';
import { AutoRow } from 'components/AutoRow';
import IframeContext, { IIframeContext } from 'contexts/IframeContext';
import { ActionTitle } from 'components/AutoRow/components/ActionTitle';
import { IMapContainer, Map } from 'components/Map';

const IframeAtendimento = ({ history }: RouteComponentProps) => {
  const [mapLatLng, setMapLatLng] = useState<[number, number]>([-1.440077, -48.471985]);
  const mapElement = useRef<IMapContainer>();
  const { dadosConsultaAreaColeta, handleBuscarAreaColeta, setDadosConsultaAreaColeta } = useContext<IIframeContext>(
    IframeContext,
  );

  const { loading, enderecoBuscado } = dadosConsultaAreaColeta;

  const handleSearch = async () => {
    const success = await handleBuscarAreaColeta();

    if (success) history.push('/coleta');
  };

  return (
    <FrameData>
      <Form id="form-busca" onSubmit={(e) => e.preventDefault()}>
        <AutoRow>
          <ActionTitle label="Atendimento" />

          <OpenCard>
            <TitleCard>Detalhes do atendimento</TitleCard>
            <SubitleCard>
              <b>Início do atendimento:</b> 06/01/2025 23:34
            </SubitleCard>
            <SubitleCard>
              <b>Final do atendimento:</b> 06/01/2025 23:34
            </SubitleCard>
            <SubitleCard>
              <b>Status do atendimento:</b> Atendido
            </SubitleCard>
            <SubitleCard>
              <b>Motivo:</b> Lâmpada queimada
            </SubitleCard>
            <SubitleCard>
              <b>Solução:</b> Troca itens
            </SubitleCard>
            <SubitleCard>
              <b>Equipe do atendimento:</b> EQUIPE 4
            </SubitleCard>
          </OpenCard>
          <OpenCard>
            <TitleCard>Mais informações</TitleCard>
            <ImageContent>
              <img />
              <img />
            </ImageContent>
          </OpenCard>
          <MapCard>
            <Map
              scrollWheelZoom
              doubleClickZoom={false}
              zoom={14}
              coords={mapLatLng}
              refMapElement={mapElement}
              maxZoom={30}
            />
          </MapCard>
        </AutoRow>
      </Form>
    </FrameData>
  );
};

export default IframeAtendimento;
